import { ActionTypes } from '../constants/index';

export const getNotesDetails = (payload: any) => ({
  type: ActionTypes.NOTES_DETAILS_LIST_REQUEST,
  payload: {
    id: payload.id,
    page: payload.page + 1,
    rowsPerPage: payload.rowsPerPage,
  },
});
